// Import the edliy_utils
import {
    makeResponsive,
    placeTitle,
    placeImage,
    placeInput,
    placeSlider,
    hoverMe,
    placeRec,
    hiddenPt,
    fixedPt,
    clearInputFields,
    dragMe,
    placeArrow,
    placeGravity,
    placeText,
    placeLine,
    placePoint,
    placeGlider,
    placeRuler,
    placeLeftText,
    placeRightText,
    placeSliderSwitch,
    placeDash,
    placeCircle
} from '../../../common/edliy_utils-bernoulli';
const Boxes = {
  box1: function () {
  var brd2 = JXG.JSXGraph.initBoard('jxgbox1',{boundingbox: [-6, 6, 6, -6],
  keepaspectratio: true, axis:true, ticks:{visible:false},
  grid:true, showCopyright:false, showNavigation:false,
  pan:{enabled:false}, zoom:{enabled:false}});
  brd2.suspendUpdate();
  brd2.options.board.minimizeReflow = 'none';
  brd2.options.text.highlight =false;
  brd2.options.text.fixed =true;
  brd2.options.text.highlight =false;
  brd2.options.text.cssStyle='fontFamily:Oswald',
  brd2.options.image.highlight =false;
  brd2.options.polygon.highlight =false;
  brd2.options.line.highlight =false;
  brd2.options.point.highlight =false;
  brd2.options.curve.highlight =false;
  brd2.options.slider.highlight =false;
  brd2.options.circle.highlight =false;
  brd2.options.point.showInfoBox =false;
  brd2.options.image.layer =15;
  brd2.options.point.layer =16;
//brd1.options.layer['image'] =14;
//Title and tetxs
  makeResponsive(brd2);
  placeTitle(brd2, 'Magnetic Field of a Bar Magnet', 'Drag the compass the trace the field lines');
  var slid =brd2.create('slider', [[-1, -3.],[1, -3],[1, 4, 16]], {snapwidth:1,
  baseline:{strokeWidth:7, strokeColor:'grey'},highline:{strokeWidth:7, strokeColor:'black'},
  name:'&nbsp;N',size:8,face:'square', fillColor:'grey',strokeColor:'black', withTicks:false, precision:0, label:{offset:[2,-15], fontSize:20}});
//
  var magN = brd2.create('polygon', [[-0.2, 0],[-0.2, 1],[0.2, 1],[0.2, 0]],{name:'Magnet (North)', withLabel:true, vertices:{visible:false}, fillcolor:'red', borders:{strokeColor:'red'}, fillOpacity:1, withLines:true, fixed:true});
  magN.label.setAttribute({visible:false});
  magN.on('over', function () {this.label.setAttribute({visible:true});});
  magN.on('out', function () {this.label.setAttribute({visible:false})});
//
  var magS = brd2.create('polygon', [[-0.2, 0],[-0.2, -1],[0.2, -1],[0.2, 0]],{name:'Magnet (South)', withLabel:true, vertices:{visible:false}, fillColor:'blue', borders:{strokeColor:'blue'}, fillOpacity:1, withLines:true, fixed:true});
  magS.label.setAttribute({visible:false});
  magS.on('over', function () {this.label.setAttribute({visible:true});});
  magS.on('out', function () {this.label.setAttribute({visible:false})});
  var CurveD = brd2.create('curve',[function(phi){return Math.sqrt(1+slid.Value()*1.5*Math.cos(phi)*Math.cos(phi));},[0, 0], 0, 2*Math.PI],{curveType:'polar', storkeWidth:0.5, dash:1, strokeColor:'black', visible:false});
  function CurveS(x){if(x ==1){return 1;}
  else if(x == 2){return 2;}
  else if(x == 3){return 3;}
  };
  var trace=true;
  slid.on('down', function(){return trace=false;});
  slid.on('up', function(){return trace=true;});
//var comP=brd.create('point', [1,1], {name:'', face:'circle', size:5, color:'yellow'});
//var t1 = brd.create('normal', [c1, comP]);
  var glid = brd2.create('glider', [2, 0, CurveD],{name:'', face:'plus', size:function(){return Math.round(25*brd2.canvasWidth/500.)}, strokeColor:'grey', strokeWidth:1});
  var t1 = brd2.create('tangent', [glid],{visible:false});
  var comp = brd2.create('circle',[[function(){return glid.X()}, function(){return glid.Y()}], 0.35],{name:'Compass (Drag me!)', withLabel:true, strokeColor:'black', strokeColor:'grey'});
  comp.label.setAttribute({visible:false});
  comp.on('over', function () {this.label.setAttribute({visible:true});});
  comp.on('out', function () {this.label.setAttribute({visible:false})});
  var pt1 = brd2.create('intersection', [comp, t1, 0],{size:0, name:''});
  var pt2 = brd2.create('intersection', [comp, t1, 1],{size:0, name:''});
  //var pt2 = brd.create('otherintersection', [comp, t1, pt1], {name:'', size:0});
  var needleN=brd2.create('arrow',[glid, pt1],{strokeColor:function(){if(glid.X()>0){return 'blue'} else{return 'red'}}, strokeWidth:2});
  var needleS=brd2.create('arrow',[glid, pt2],{strokeColor:function(){if(glid.X()>0){return 'red'} else{return 'blue'}}, strokeWidth:2});
  brd2.create('text',[-0.085, 0.8, 'N'],{fontSize:function(){return Math.round(18*brd2.canvasWidth/800.)}, color:'white', fixed:true});
  brd2.create('text',[-0.085, -0.8, 'S'],{fontSize:function(){return Math.round(18*brd2.canvasWidth/800.)}, color:'white', fixed:true});
  //brd2.create('text',[-1.75, -3, 'Closer'],{cssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(15*brd2.canvasWidth/500.)}, color:'black', fixed:true});
  //brd2.create('text',[1.15, -3, 'Farther'],{cssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(15*brd2.canvasWidth/500.)}, color:'black', fixed:true});
  //brd2.create('text',[-2.8, 3.1, 'Physics | Magnetic Field of a Bar Magnet'],{cssStyle:'fontFamily:Oswald',fontSize:function(){return Math.round(22*brd2.canvasWidth/500.)}, color:'black', fixed:true});
  brd2.create('point',[function(){return glid.X();}, function(){return glid.Y();}],{name:'', size:2, face:'circle', strokewidth:0, strokeColor:'grey', fillColor:'black', trace:function(){return trace.valueOf()}});

  brd2.unsuspendUpdate();
    },
}
export default Boxes;
